<div class="flex flex-col min-h-screen">
    <div class="mb-6">
        <app-header [id]="id"></app-header>
    </div>

    <ng-container *ngIf="isLoading() ; else content">


        <div class="flex items-center justify-center min-h-[300px]">
            <p-progress-spinner ariaLabel="Loading Tickets" />
        </div>
    </ng-container>

    <ng-template #content>


        <div class="flex-grow lg:pt-2 bg-gray-20 lg:border-b border-gray-300 ">
            <div class=" container mx-auto lg:px-16 lg:mb-20 px-3 space-y-4">

                <div class="flex flex-col lg:flex-row gap-4">

                    <div class="w-full lg:w-2/3 space-y-6 sm:space-y-18  " [ngClass]="{ 'hidden': mobileStep !== 1 }">

                        <h2 class="text-2xl  lg:text-3xl font-bold font-mulish md:mt-6">Order tickets</h2>
                        <div>
                            <app-tickets [tickets]="tickets" [isHomePage]="false" [id]="this.id"
                                (quantityChanged)="updateSummary($event)"></app-tickets>
                        </div>

                        <div *ngIf="discountAvailable" class="flex flex-col gap-2 w-full md:max-w-[50%]">

                            <div class="flex items-end gap-4 mt-4">
                                <div class="flex-[2]">
                                    <label class="block text-gray-500 text-base font-mulish font-semibold ">
                                        Enter Discount Code
                                    </label>
                                    <input pInputText [(ngModel)]="discountCode" placeholder="Code"
                                        class="w-full text-sm h-[38px] placeholder:font-mulish" />
                                </div>
                                <div class="flex-1 sm:flex-[1]">
                                    <button pButton class=" h-[40px] sm:h-[40px] p-button !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
                                        hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
                                        active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] rounded-m w-full
                        justify-center gap-2" [rounded]="true" (click)="getTicketsDiscount(true) "
                                        [disabled]="discountApplied" [rounded]="true">
                                        <span class="font-mulish !text-[var(--p-text-color-primary)] text-center">Apply</span>
                                    </button>
                                </div>
                            </div>

                            @if (discountApplied) {
                            <div
                                class="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-md px-4 py-2">
                                <div class="text-sm text-blue-800 font-semibold">
                                    Discount Code Applied: <span class="italic">{{ appliedDiscountCode }}</span>
                                </div>
                                <button class="text-blue-600 text-sm underline font-medium" (click)="removeDiscount()"
                                    [disabled]="discountCode">
                                    Remove
                                </button>
                            </div>
                            } @else if (discountInvalid) {
                            <div
                                class="flex items-center justify-between bg-red-50 border border-red-200 rounded-md px-4 py-2">
                                <div class="text-sm text-red-800 font-semibold">
                                    Discount Code Not Valid
                                </div>
                            </div>
                            }
                        </div>

                        @if (isAskingForDonations()) {
                        <div class="flex flex-col sm:flex-row sm:items-start sm:gap-4 ">

                            <div class="sm:flex-[3] mt-2 min-w-[200px]">
                                <label class="block text-gray-500 text-base font-mulish font-semibold mt-4">
                                    Would you like to make a Donation?
                                </label>
                                <div
                                    class="flex flex-wrap justify-between items-center border-2 border-[var(--p-primary-500)] rounded-xl overflow-hidden h-[40px] mt-1 w-full">
                                    <button *ngFor="let amount of amounts" (click)="updateDonationAmount(amount)"
                                        class=" flex-1 text-center text-sm sm:text-base px-2 sm:px-4 py-2 rounded-lg  font-medium focus:outline-none transition h-full min-w-[60px]"
                                        [ngClass]="{
                                    'bg-[var(--p-primary-500)] !text-[var(--p-text-color-primary)]': selectedAmount === amount,
                                    'text-[var(--p-primary-500)] hover:bg-[var(--p-gray-100)]': selectedAmount !== amount
                                    }">
                                        ${{ amount }}
                                    </button>
                                </div>
                            </div>

                            <div class="sm:flex-[2] mt-6 min-w-[180px] lg:mb-10">
                                <label class="block text-gray-500 text-base font-mulish font-semibold tracking-wide">
                                    Other Amount
                                </label>
                                <input pInputText class="w-full mt-1 h-[40px] " placeholder="$"
                                    [(ngModel)]="otherAmount" (input)="updateDonationAmount(otherAmount, true)"
                                    name="customAmount" />
                            </div>
                        </div>
                        }

                        <div class="">
                            <label class="block text-gray-500 text-base font-mulish font-semibold tracking-wide">
                                {{ticketEventSignal()?.textBoxLabel ?? 'Comments'}}
                                @if (isAnswerRequired()) {
                                    <span class="text-red-500">*</span>
                                }
                            </label>
                            <textarea pInputTextarea rows="5" [(ngModel)]="comment"
                                class="w-full border border-gray-300 p-2 rounded-md mb-6 lg:mb-2"
                                [required]="isAnswerRequired()"></textarea>
                        </div>

                        <div class="flex gap-2 pt-10 md:pt-15 ">

                            <button pButton type="button"
                                class=" h-[40px] lg:h-[35px] !bg-white !border 
                                        !border-[var(--p-info-500)] 
                                        hover:!border-[var(--p-info-600)] 
                                        active:!border-[var(--p-info-700)] !text-[var(--p-info-500)]  px-4 py-2 font-medium text-base flex-[1] !rounded-full flex justify-end items-center"
                                (click)="goBack()">
                                <i class="pi pi-angle-double-left text-xl"></i>
                                <span class="font-semibold  text-center w-full text-base">
                                    Cancel
                                </span>
                            </button>

                            <button pButton class=" h-[40px] lg:h-[35px] !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
                                        hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
                                        active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] p-button rounded-m w-full relative flex-[4] flex items-center
                        justify-center gap-2" [rounded]="true" (click)="isMobile ? (mobileStep = 2) : showGuestInfo()"
                                [disabled]="!hasTicketSelected || (isAnswerRequired() && (comment == null || comment.length === 0))">
                                <i class="pi pi-angle-double-right  !text-[var(--p-text-color-primary)] text-lg left-3">
                                </i>
                                <span class="font-semibold !text-[var(--p-text-color-primary)] text-center w-full text-base">
                                    Next
                                </span>
                            </button>
                        </div>

                        <div class="mb-10 " *ngIf="showWinningBidText()">
                            <ng-container *ngTemplateOutlet="winningBidText"></ng-container>

                        </div>
                    </div>

                    <div class="w-full lg:w-1/3 p-4 rounded-xl" [ngClass]="{ 'hidden': isMobile && mobileStep !== 2 }">
                        <h2 class=" block md:hidden text-2xl font-bold font-mulish">Order Tickets</h2>
                        <h2 class="text-2xl font-semibold mb-4 mt-6 lg:mt-4 px-3" style="color: var(--p-info-500);">Summary
                        </h2>
                        <ng-container *ngTemplateOutlet="summaryContent" class="px-3"></ng-container>

                    </div>
                </div>
            </div>
        </div>


        <ng-template #summaryContent>
            <div class="text-sm  rounded-lg mb-18 bg-white shadow-md rounded-lg px-3 mt-6">
                <p class="font-mulish font-medium pt-4 text-[16px] mb-8">Please review the information below and make
                    any
                    changes in this step.</p>
                <div *ngFor="let ticket of selectedTickets" class="">

                    <p class="text-sm font-semibold font-mulish flex justify-between"
                        style="color: var(--panorama-gray);">
                        {{ticket.quantitySelected!}} {{
                        ticket.name }}
                        <span class="font-semibold ml-10 lg:ml-20 font-mulish text-black text-sm">
                            {{ ticket.price}} {{currency()}}
                        </span>
                    </p>
                </div>
                <div *ngIf="selectedAmount || otherAmount">
                    <p class="text-sm font-semibold font-mulish flex justify-between"
                        style="color: var(--panorama-gray);">
                        Donation Amount:
                        <span class="font-semibold ml-10 font-mulish text-black text-sm">
                            ${{ (otherAmount ?? selectedAmount) | number: '1.2-2' }} {{currency()}}
                        </span>
                    </p>
                </div>
                <div class="mt-10 pt-6 border-t border-gray-200">
                    <p class="text-lg font-semibold font-mulish  flex justify-between">
                        Subtotal:
                        <span class="font-semibold ml-10 font-mulish text-black text-lg  pb-6">
                            ${{ subtotal}} {{currency()}}
                        </span>
                    </p>

                </div>
            </div>

            <div *ngIf="isMobile && mobileStep !== 1">
                <ng-container *ngTemplateOutlet="SummaryButtons"></ng-container>
            </div>
            <div class="block lg:hidden mt-4" *ngIf="showWinningBidText()">
                <ng-container *ngTemplateOutlet="winningBidText"></ng-container>
            </div>

        </ng-template>

        <ng-template #winningBidText>
            <div class="mb-10 ">
                <p class="text-xs text-gray-700 pt-2 font font-mulish  text-center">
                    Your payment is being made to <a href="#" class="text-blue-500 underline">FrontStream Global
                        Fund</a>
                    (tax
                    ID 26-3265577), a 501c3 nonprofit organization,
                    which will send your donation to {{homePageSignal()?.orgName}} (tax ID {{homePageSignal()?.taxId}})
                    on
                    your
                    behalf.
                </p>
            </div>
        </ng-template>

        <ng-template #SummaryButtons>
            <div class="mt-10 flex gap-2 lg:hidden pt-12">

                <button pButton type="button"
                    class="  h-[35px] !bg-white !border !border-custom-blue !text-custom-blue px-4 py-2 font-medium text-base flex-[1] !rounded-full flex justify-end items-center"
                    (click)="mobileStep = 1">
                    <i class="pi pi-angle-double-left text-xl"></i>
                </button>

                <button pButton
                    class=" h-[35px] !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] rounded-m w-full relative flex-[4] flex items-center justify-center gap-2"
                    [rounded]="true" (click)="showGuestInfo()">
                    <i class="pi pi-credit-card !text-[var(--p-text-color-primary)] text-xs left-3">
                    </i>
                    <span class="font-semibold !text-[var(--p-text-color-primary)] text-center w-full text-base">
                        Next
                    </span>
                </button>
            </div>

        </ng-template>
        <app-embedded-payment [token]="token" [(visible)]="visibleEmbedded"></app-embedded-payment>
        <app-zero-purchase-thankyou-page *ngIf="thankYouData" [thankYouData]="thankYouData"
            [(visible)]="showThankYouPageModal">
        </app-zero-purchase-thankyou-page>

    </ng-template>

    <div class="">
        <app-footer></app-footer>
    </div>
</div>

@if(loadingEPF()){
<div class="fixed inset-0 z-50 flex items-center justify-center min-h-[300px]">
    <p-progress-spinner ariaLabel="loading" />
</div>
}